<template>
  <div class="panel-root stack tight">
    <UiSectionHeader>
      <template #title>{{ ICONS.places.building }} Buildings</template>
      <template #actions>
        <UiChip variant="muted" class="stat-mono num">{{ formatNumber(locations.length) }}</UiChip>
      </template>
    </UiSectionHeader>

    <UiCallout v-if="inCombat" variant="warning">
      {{ ICONS.domains.combat }} Cannot visit/leave buildings during combat.
    </UiCallout>
    <UiCallout v-else-if="isLoading" variant="info">Loading location…</UiCallout>
    <UiCallout v-else-if="locations.length === 0" variant="info">No buildings here.</UiCallout>

    <div v-else class="list panel-scroll scroll">
      <BuildingRow
        v-for="loc in locations"
        :key="loc.id"
        :location="loc"
        :isInside="currentLocationId === loc.id"
        :disabled="isLoading || inCombat"
        :isBlocked="inCombat"
        blockedReason="Cannot visit during combat"
        @enter="emit('enter', $event)"
        @exit="emit('exit')"
        @open-service="emit('open-service', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Location } from "@idle-rpg/shared";
import { ICONS } from "../../lib/icons";
import { formatNumber } from "../../lib/format";
import BuildingRow from "../world/rows/BuildingRow.vue";
import UiCallout from "../ui/UiCallout.vue";
import UiChip from "../ui/UiChip.vue";
import UiSectionHeader from "../ui/UiSectionHeader.vue";

defineProps<{
  locations: Location[];
  currentLocationId: string | null;
  inCombat: boolean;
  isLoading?: boolean;
}>();

const emit = defineEmits<{
  enter: [locationId: string];
  exit: [];
  "open-service": [service: "bank" | "exchange"];
}>();
</script>

<style scoped>
.panel-root {
  min-width: 0;
}

.list {
  display: grid;
  gap: 0.6rem;
}
</style>
